import { render, staticRenderFns } from "./OrganisationSelectList.vue?vue&type=template&id=778f010e&"
import script from "./OrganisationSelectList.vue?vue&type=script&lang=ts&"
export * from "./OrganisationSelectList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports